import { jwtDecode } from "jwt-decode";

export const getToken = () => {
  return localStorage.getItem("access_token");
};

export const isTokenValid = () => {
  const token = getToken();
  if (!token) return false;

  try {
    const { exp } = jwtDecode(token);
    return exp * 1000 > Date.now();
  } catch {
    return false;
  }
};